import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
  },
  stepContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.25),
    padding: theme.spacing(2),
    "&:last-child": {
      paddingBottom: theme.spacing(2),
    },
  },
  stepTitle: {
    fontWeight: 600,
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
  groupHeaderContainer: {
    border: `1px solid ${theme.palette.programingOnDemandGrouped.headerBorder}`,
    boxShadow: "none",
    "& .MuiAccordionSummary-expandIcon": {
      padding: 0,
    },
    "& .MuiAccordionSummary-root": {
      gap: theme.spacing(2),
      minHeight: 0,
    },
    "& .MuiAccordionSummary-content": {
      margin: 0,
    },
    "& .MuiButtonBase-root": {
      alignItems: "flex-start",
    },
    "& .MuiIconButton-label": {
      display: "block",
      lineHeight: 1,
    },
  },
  groupPanelTitleContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "center",
    },
  },
  groupHeader: {
    fontWeight: 600,
    fontSize: "1.25rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.1rem",
    },
  },
  groupHeaderInfo: {
    [theme.breakpoints.down("sm")]: {
      alignSelf: "flex-end",
    },
  },
}));